$(function(){
    updateSwiper();
})

$(window).resize(function(){
    updateSwiper();
})

function UpdateProductToCart(item){
  let formData = {
    updates: item,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}

function updateSwiper(){


    $(".custom-list-swiper").each(function(){
      if($(window).width() < 750){
        $(this).attr("slides-per-view", $(this).attr("data-mob"));
      }
      else{
        $(this).attr("slides-per-view", $(this).attr("data-desk"));
      }
    })
    if($(window).width() < 990){
        $(".custom-feed-swiper").attr("slides-per-view", 3);
    }
    else{
        $(".custom-feed-swiper").attr("slides-per-view", 6);
    }

    if($(window).width() < 750){
      $(".custom-logos-slider-swiper").attr("slides-per-view", 3);
    }
    else{
      $(".custom-logos-slider-swiper").attr("slides-per-view", 4);
    }

    if($(window).width() <= 550){
        $(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("1280")
    }
    else if($(window).width() <= 749){
        $(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("1024")
    }
    else if($(window).width() <= 989){
        $(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("989")
    }
    else if($(window).width() <= 1024){
        $(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("749")
    }
    else if($(window).width() <= 1280){
        $(".custom-reviews-swiper").attr("slides-per-view", 3);
        console.log("550")
    }
    else{
        $(".custom-reviews-swiper").attr("slides-per-view", 4);
        console.log("else")
    }
}

$(".custom-faq-block-title").click(function(){
  $(this).parent().toggleClass("active");
  $(this).next(".custom-faq-block-content").slideToggle(250);
})

$(".new-faq-block-title").click(function(){
    if($(this).parent().hasClass("active")){
        $(this).parent().toggleClass("active");
        $(this).next(".new-faq-block-content").slideToggle(250);
    }
    else{
        $(this).parents(".new-faq-block-container").find(".new-faq-block").removeClass("active");
        $(this).parents(".new-faq-block-container").find(".new-faq-block-content").slideUp(250);
        $(this).parent().addClass("active");
        $(this).next(".new-faq-block-content").slideDown(250);
    }
})

$(".new-faq-cat-list-item").click(function(){
  let top = $(`.new-faq-block-heading[data-title=${$(this).attr("data-title")}]`).offset().top;
  $('html,body').animate({scrollTop: top}, 500);
})

$(".custom-acc-title-wrapper").click(function(){
  if($(this).hasClass("active")){
      $(this).toggleClass("active");
      $(this).next(".custom-acc-content").slideToggle(250);
  }
  else{
      $(this).parents(".custom-acc-wrapper").find(".custom-acc-title-wrapper").removeClass("active");
      $(this).parents(".custom-acc-wrapper").find(".custom-acc-content").slideUp(250);
      $(this).addClass("active");
      $(this).next(".custom-acc-content").slideDown(250);
  }
})

$(".footer-block__heading").click(function(){
    if($(this).hasClass("active")){
        $(this).toggleClass("active");
        $(this).next(".footer-block__details-content").slideToggle(250);
    }
    else{
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__heading").removeClass("active");
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__details-content").slideUp(250);
        $(this).addClass("active");
        $(this).next(".footer-block__details-content").slideDown(250);
    }
});

$(document).on("click", ".custom-cart-upsell-atc", function(){
    let arr = [];
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
    AddUpsellToCart(arr, $(this));
})

$(".custom-hotspots-item").click(function(){
  $(this).parent().find(".custom-hotspots-item").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".custom-hotspots").find(".custom-hotspots-mobile-text").text($(this).find(".custom-hotspots-text").text());
})

$(document).on("click", ".custom-addon-atc", function(){
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddUpsellToCart(arr, $(this), true);
})

$(document).on("click", ".new-card-product-atc", function(e){
  e.preventDefault();
  e.stopPropagation();
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddUpsellToCart(arr, $(this), true);
})

$(document).on("click", ".new-cart-cross-btn", function(e){
  e.preventDefault();
  e.stopPropagation();
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddUpsellToCart(arr, $(this));
})

$(".custom-mobile-search-icon").click(function(){
  $(".header__icon--search .icon-search")[0].dispatchEvent(new PointerEvent('click'));
})

function AddUpsellToCart(productsArr, $this, open=false){
    $this.addClass("active");
    let formData = {
      'items': productsArr,
      sections: "cart-drawer,cart-icon-bubble"
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if(res.status){
        console.log(res);
      }
      else{
        const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
        const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        $("cart-drawer.drawer").removeClass("is-empty");
        $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
        $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        if(open){
          document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
          $(".cart-count-bubble").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
  }

  $(document).on("click", ".custom-header-drawer-close", function(){
    $(".header__icon--menu").trigger("click");
  })

  $(document).on("click", ".custom-pdp-video-play", function(){
    $(this).fadeOut();
    $(this).parent().find(".custom-pdp-video").trigger("play").attr("controls", "true");
  })

    $(document).on("click", ".custom-pdp-video-play-ecomix", function(){
    $(this).fadeOut();
    $(this).parent().find(".testimonial-video").trigger("play").attr("controls", "true");
  })

  $(document).on("click", ".custom-main-product-media-next-zone", function(){
    $(this).parent().find(".custom-main-product-media-swiper")[0].swiper.slideNext();
  })

  $(document).on("click", ".custom-main-product-media-prev-zone", function(){
    $(this).parent().find(".custom-main-product-media-swiper")[0].swiper.slidePrev();
  })

  $(document).on("click", ".custom-main-product-media-zoom-btn", function(){
    $(this).parent().find(".custom-main-product-media-swiper").find(".swiper-slide-active").find("a").get(0).click();
  })
  
  if (window.Fancybox) Fancybox.bind("[data-fancybox]", {});

  $(document).on("change", "#cart-footer-prod-checkbox", function(){
  let vid = $(this).data("vid");
  let formData = {
    updates: {}
  };
  
  // quantity update
  formData.updates[vid] = $(this).is(":checked") ? 1 : 0;

  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      ...formData,
      sections: ['cart-drawer', 'cart-icon-bubble'],  // tell which sections you want updated
      sections_url: window.location.pathname         // required so it knows the context
    })
  })
  .then(res => res.json())
  .then(res => {
    // Replace drawer
    if (res.sections['cart-drawer']) {
      $("cart-drawer.drawer").removeClass("is-empty");
      document.querySelector('.drawer__inner').innerHTML =
        new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html')
          .querySelector('.drawer__inner').innerHTML;
    }

    // Replace bubble
    if (res.sections['cart-icon-bubble']) {
      document.querySelector('.cart-icon-bubble').innerHTML =
        new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section').innerHTML;
    }
  })
  .catch(err => console.error('Error updating cart:', err));
});


// $(function(){
//   if($("#cart-footer-prod-checkbox").length > 0){
//   let vid = $("#cart-footer-prod-checkbox").data("vid");
//   let formData = {
//     updates: {}
//   };
  
//   // quantity update
//   formData.updates[vid] = 1;

//   fetch(`${window.Shopify.routes.root}cart/update.js`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     },
//     body: JSON.stringify({
//       ...formData,
//       sections: ['cart-drawer', 'cart-icon-bubble'],  // tell which sections you want updated
//       sections_url: window.location.pathname         // required so it knows the context
//     })
//   })
//   .then(res => res.json())
//   .then(res => {
//     // Replace drawer
//     if (res.sections['cart-drawer']) {
//       $("cart-drawer.drawer").removeClass("is-empty");
//       document.querySelector('.drawer__inner').innerHTML =
//         new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html')
//           .querySelector('.drawer__inner').innerHTML;
//     }

//     // Replace bubble
//     if (res.sections['cart-icon-bubble']) {
//       document.querySelector('.cart-icon-bubble').innerHTML =
//         new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html')
//           .querySelector('.shopify-section').innerHTML;
//     }
//   })
//   .catch(err => console.error('Error updating cart:', err));
//   }
// });





$(document).ready(function() {
    $('.custom-main-product-swatch').hover(function() {     
        const pTitle = $(this).attr('p-title');
        $('.p-tooltip').text(pTitle);
    });
});





$(function () {
  const $submitBtn = $(".custom-buy-buttons-wrapper .product-form__submit");
  const $stickyWrapper = $(".new-sticky-bar-wrapper");
  const $stickyBtn = $(".new-sticky-bar-btn");

  if (!$submitBtn.length || !$stickyWrapper.length) return;

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  function updateStickyVisibility() {
    const isVisible = isElementInViewport($submitBtn[0]);

    // ✅ Show sticky when main button is NOT visible
    $stickyWrapper.toggleClass("active", !isVisible);
  }

  // Run on load (IMPORTANT for mobile)
  updateStickyVisibility();

  // Run on scroll + resize
  $(window).on("scroll resize", function () {
    updateStickyVisibility();
  });

  // Sticky click triggers main ATC
  $stickyBtn.on("click", function () {
    $submitBtn.trigger("click");
  });
});


//click judgme to slide to review section
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const badge = document.querySelector('.jdgm-preview-badge');
    if (badge && !badge.dataset.clickBound) {
      badge.style.cursor = 'pointer';
      badge.dataset.clickBound = true;

      badge.addEventListener('click', () => {
        const target = document.querySelector('#product-testimonials');
        if (target) {
          const yOffset = -100; 
          const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

//google reviews link block
document.addEventListener("DOMContentLoaded", function() {
  function disableGoogleReviewLink() {
    const reviewBlock = document.querySelector("#shopify-block-AME9POHhSdW9NL2lac__google_reviews_compact_widget_block_HAnnAn a.reputon-link");
    if (reviewBlock) {
      reviewBlock.removeAttribute("href");
      reviewBlock.style.pointerEvents = "none";
      reviewBlock.style.cursor = "default";
    } else {
     
      setTimeout(disableGoogleReviewLink, 500);
    }
  }
  disableGoogleReviewLink();
});



document.addEventListener('DOMContentLoaded', () => {

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  console.log('Cart Update Source:', event.source);

 
if (typeof window.autoAddInsurance !== "undefined" && !window.autoAddInsurance) return;

  // WHEN PRODUCT IS ADDED FROM PDP
  if (event.source === 'product-form') {

    const pid = $("body").attr("data-pid");

    if (pid) {
      UpdateProductToCart({
        [pid]: 1
      });
    }
  }

  // OPTIONAL: remove logic
  else if (event.source === 'cart-items') {

    const pid = $("body").attr("data-pid");

    if (pid) {
      if (pid == event.cartData.items[0].id && event.cartData.item_count == 1) {
        UpdateProductToCart({
          [pid]: 0
        });
      }
    }
  }
});

});

$(document).on("change", ".new-cp-inp", function(){
  if($(this).is(":checked")){
    UpdateProductToCart({
      [$(this).val()]: 1
    });
  }
  else{
    UpdateProductToCart({
      [$(this).val()]: 0
    });
  }
})
